export default "__VITE_ASSET__nhVT$OT2__"